<template>
  <div class="container gray-bcg mt-10">
    <div class="row d-flex justify-content-center mb-16">
      <div class="col-12 gray-bcg">
        <v-carousel
          cycle
          height="35rem"
          hide-delimiter-background
          light
          class="mt-5 hidden-sm-and-down hidden-md-and-down"
        >
          <v-carousel-item v-for="index in commentsDividedRounde" :key="index">
            <v-row
              class="px-16 gray-bcg font14"
              align="center"
              justify="center"
              dense
            >
              <div
                class="col-5 card m-1 staticHight"
                v-for="comment in comments.slice(
                  indexLoop + 4 * index,
                  indexLoop + 4
                )"
                :key="comment.first_name"
              >
                <v-list-item three-line>
                  <v-list-item-avatar
                    align="right"
                    size="70"
                    color="grey"
                  ></v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title class="text-h5 mb-1">
                      {{ comment.first_name }}
                    </v-list-item-title>
                    <v-rating
                      v-model="comment.star"
                      length="5"
                      readonly
                      background-color="orange lighten-3"
                      color="orange"
                      small
                      dense
                    ></v-rating>
                    <div class="col-12">{{ comment.opinion }}</div>
                  </v-list-item-content>
                </v-list-item>
              </div>
            </v-row>
          </v-carousel-item>
        </v-carousel>
        <v-carousel
          cycle
          height="21rem"
          hide-delimiter-background
          light
          class="mt-5 d-lg-none"
        >
          <v-carousel-item
            v-for="comment1 in comments"
            :key="comment1.first_name"
          >
            <v-row
              class="px-16 gray-bcg font14"
              align="center"
              justify="center"
              dense
            >
              <div
                class="col-12 w-100 card mb-n16 d-lg-none"
                style="height: 20em"
              >
                <v-list-item two-line>
                  <v-list-item-avatar
                    class="mt-n16"
                    size="50"
                    color="grey"
                  ></v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title class="text-h5 mb-1">
                      {{ comment1.first_name }}
                    </v-list-item-title>
                    <v-rating
                      v-model="comment1.star"
                      length="5"
                      readonly
                      background-color="orange lighten-3"
                      color="orange"
                      small
                      dense
                    ></v-rating>
                    <div class="col-12">
                      {{ comment1.opinion }}
                    </div>
                  </v-list-item-content>
                </v-list-item>
              </div>
            </v-row>
          </v-carousel-item>
        </v-carousel>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      indexLoop: 0,
      comments: [],
      commentsDivided: [],
      commentsDividedRounde: "",
    };
  },
  mounted() {
    this.axios.get("get_confirm_opinion").then((response) => {
      console.log(response.data[0]);
      this.comments = response.data[0];
      console.log(this.comments.length / 4);
      this.commentsDivided = this.comments.length / 2;
      this.commentsDividedRounde = Math.floor(this.commentsDivided);
    });
  },
};
</script>
<style scoped>
.staticHight {
  height: 15rem;
}
</style>
